(() => {
  const host = document.querySelector('soffa-accessibility');
  if (!host || host.dataset.ready) return;
  const dialog = host.querySelector('dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  host.dataset.ready = 'true';
  const root = document.documentElement;
  const launcher = host.querySelector('.soffa-a11y-launch');
  const sizes = [1, 1.25, 1.5, 1.75, 2];
  const key = 'soffa-reading-preferences-v1';
  const defaults = () => ({ size: 0, words: 0, letters: 0, color: '', links: false, motion: false, font: false, images: false, headings: false, guide: false, cursor_dark: false, cursor_light: false });
  let prefs = defaults();
  try {
    const saved = JSON.parse(localStorage.getItem(key));
    if (saved && typeof saved === 'object') {
      prefs.size = Number.isInteger(saved.size) && saved.size >= 0 && saved.size < sizes.length ? saved.size : 0;
      for (const name of ['links', 'motion', 'font', 'images', 'headings', 'guide', 'cursor_dark', 'cursor_light']) prefs[name] = saved[name] === true;
      for (const name of ['words', 'letters']) prefs[name] = Number.isInteger(saved[name]) && saved[name] >= 0 && saved[name] <= 4 ? saved[name] : saved.spacing === true ? 1 : 0;
      prefs.color = ['high', 'inverted', 'gray', 'mono'].includes(saved.color) ? saved.color : '';
    }
  } catch (_) {}
  const motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
  const tagged = new Set();
  const paused = new Map();
  let pending = 0;
  let returnFocus = launcher;

  function resizeText() {
    root.setAttribute('data-soffa-a11y-measuring', '');
    root.removeAttribute('data-soffa-a11y-size');
    if (!prefs.size) {
      for (const el of tagged) {
        el.removeAttribute('data-soffa-a11y-font');
        el.style.removeProperty('--soffa-a11y-font');
        el.style.removeProperty('--soffa-a11y-line');
      }
      tagged.clear();
      root.style.removeProperty('--soffa-a11y-scale');
      root.removeAttribute('data-soffa-a11y-measuring');
      return;
    }
    const readings = [];
    for (const el of document.body.querySelectorAll('*')) {
      if (!(el instanceof HTMLElement) || el.closest('script,style,noscript,svg,template,option') || el.classList.contains('visually-hidden')) continue;
      if (!['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName) && ![...el.childNodes].some(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim())) continue;
      const style = getComputedStyle(el);
      const size = parseFloat(style.fontSize);
      if (!size) continue;
      readings.push([el, size, Math.max(1.3, parseFloat(style.lineHeight) / size || 1.5)]);
    }
    for (const [el, size, line] of readings) {
      el.style.setProperty('--soffa-a11y-font', `${size}px`);
      el.style.setProperty('--soffa-a11y-line', String(line));
      el.setAttribute('data-soffa-a11y-font', '');
      tagged.add(el);
    }
    for (const el of tagged) if (!el.isConnected) tagged.delete(el);
    root.style.setProperty('--soffa-a11y-scale', sizes[prefs.size]);
    root.setAttribute('data-soffa-a11y-size', '');
    root.removeAttribute('data-soffa-a11y-measuring');
  }

  function reduceMotion() {
    const reduced = prefs.motion || motionQuery.matches;
    root.toggleAttribute('data-soffa-a11y-motion', reduced);
    if (reduced) {
      for (const el of document.querySelectorAll('slideshow-component[autoplay],announcement-bar-component[autoplay]')) {
        if (typeof el.pause !== 'function') continue;
        if (!paused.has(el)) paused.set(el, !el.paused);
        el.pause();
      }
      for (const video of document.querySelectorAll('video[autoplay]')) video.pause();
    } else {
      for (const [el, wasPlaying] of paused) if (wasPlaying && el.isConnected && typeof el.resume === 'function') {
        el.paused = false;
        el.resume();
      }
      paused.clear();
    }
  }

  function apply(save = true) {
    root.toggleAttribute('data-soffa-a11y-links', prefs.links);
    if (prefs.color) root.setAttribute('data-soffa-a11y-color', prefs.color);
    else root.removeAttribute('data-soffa-a11y-color');
    for (const name of ['words', 'letters']) {
      root.toggleAttribute(`data-soffa-a11y-${name}`, prefs[name] > 0);
      root.style.setProperty(`--soffa-a11y-${name}`, `${prefs[name] * (name === 'words' ? 0.08 : 0.02)}em`);
    }
    for (const button of host.querySelectorAll('[data-a11y-color]')) button.setAttribute('aria-pressed', String(prefs.color === button.dataset.a11yColor));
    for (const button of host.querySelectorAll('[data-a11y-toggle]')) button.setAttribute('aria-pressed', String(prefs[button.dataset.a11yToggle]));
    for (const input of host.querySelectorAll('[data-a11y-option]')) input.checked = prefs[input.dataset.a11yOption];
    for (const name of ['size', 'words', 'letters']) {
      host.querySelector(`[data-a11y-value="${name}"]`).textContent = name === 'size' ? `${sizes[prefs.size] * 100}%` : String(prefs[name]);
      host.querySelector(`[data-a11y-adjust="${name}"][data-step="-1"]`).disabled = prefs[name] === 0;
      host.querySelector(`[data-a11y-adjust="${name}"][data-step="1"]`).disabled = prefs[name] === 4;
    }
    for (const name of ['font', 'images', 'headings', 'cursor_dark', 'cursor_light']) root.toggleAttribute(`data-soffa-a11y-${name}`, prefs[name]);
    host.querySelector('.soffa-reading-guide').hidden = !prefs.guide;
    resizeText();
    reduceMotion();
    if (save) try { localStorage.setItem(key, JSON.stringify(prefs)); } catch (_) {}
  }

  launcher.addEventListener('click', () => {
    returnFocus = document.activeElement;
    dialog.showModal();
    host.querySelector('h2').focus();
  });
  host.querySelector('[data-a11y-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href]')].filter(el => el.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === host.querySelector('h2'))) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  dialog.addEventListener('close', () => {
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  for (const button of host.querySelectorAll('[data-a11y-adjust]')) button.addEventListener('click', () => {
    const name = button.dataset.a11yAdjust;
    prefs[name] = Math.max(0, Math.min(4, prefs[name] + Number(button.dataset.step)));
    apply();
  });
  for (const button of host.querySelectorAll('[data-a11y-adjust-reset]')) button.addEventListener('click', () => {
    prefs[button.dataset.a11yAdjustReset] = 0;
    apply();
  });
  for (const button of host.querySelectorAll('[data-a11y-color]')) button.addEventListener('click', () => {
    prefs.color = prefs.color === button.dataset.a11yColor ? '' : button.dataset.a11yColor;
    apply();
  });
  for (const button of host.querySelectorAll('[data-a11y-toggle]')) button.addEventListener('click', () => {
    const name = button.dataset.a11yToggle;
    prefs[name] = !prefs[name];
    if (name === 'cursor_dark' && prefs[name]) prefs.cursor_light = false;
    if (name === 'cursor_light' && prefs[name]) prefs.cursor_dark = false;
    apply();
  });
  for (const input of host.querySelectorAll('[data-a11y-option]')) input.addEventListener('change', () => {
    prefs[input.dataset.a11yOption] = input.checked;
    apply();
  });
  host.querySelector('[data-a11y-reset]').addEventListener('click', () => {
    prefs = defaults();
    stopReading();
    actionsEnabled = false;
    try { sessionStorage.removeItem('soffa-click-speech'); } catch (_) {}
    actionsButton.setAttribute('aria-pressed', 'false');
    apply(false);
    try { localStorage.removeItem(key); } catch (_) {}
    const status = host.querySelector('[data-a11y-status]');
    status.textContent = status.dataset.resetMessage;
  });
  const actionsButton = host.querySelector('[data-a11y-actions]');
  const speechStatus = host.querySelector('[data-a11y-speech-status]');
  let actionsEnabled = false;
  try { actionsEnabled = sessionStorage.getItem('soffa-click-speech') === 'true'; } catch (_) {}
  actionsButton.setAttribute('aria-pressed', String(actionsEnabled));
  let activeUtterance;
  let actionTimer;
  const language = (root.lang || 'he').split('-')[0];
  const normalize = value => value.toLowerCase().split(/[-_]/)[0].replace(/^iw$/, 'he');
  const getVoice = () => {
    const voices = window.speechSynthesis?.getVoices() || [];
    return voices.filter(v => normalize(v.lang) === normalize(language)).sort((a, b) => Number(b.localService) - Number(a.localService))[0];
  };
  function stopReading() {
    window.speechSynthesis?.cancel();
    activeUtterance = null;
    speechStatus.hidden = true;
  }
  function speechFailed() {
    stopReading();
    actionsEnabled = false;
    try { sessionStorage.removeItem('soffa-click-speech'); } catch (_) {}
    actionsButton.setAttribute('aria-pressed', 'false');
    speechStatus.textContent = host.dataset.noVoice;
    speechStatus.hidden = false;
  }
  function speak(text, done) {
    if (!('speechSynthesis' in window) || !('SpeechSynthesisUtterance' in window)) { speechFailed(); done?.(); return; }
    const voice = getVoice();
    activeUtterance = new SpeechSynthesisUtterance(text);
    activeUtterance.lang = voice?.lang || (language === 'he' ? 'he-IL' : root.lang);
    if (voice) activeUtterance.voice = voice;
    activeUtterance.rate = 0.95;
    activeUtterance.onend = done;
    activeUtterance.onerror = event => {
      if (!['interrupted', 'canceled'].includes(event.error)) { speechFailed(); done?.(); }
    };
    window.speechSynthesis.speak(activeUtterance);
  }
  actionsButton.addEventListener('click', () => {
    const enabled = !actionsEnabled;
    stopReading();
    actionsEnabled = enabled;
    try { sessionStorage.setItem('soffa-click-speech', String(enabled)); } catch (_) {}
    actionsButton.setAttribute('aria-pressed', String(enabled));
    if (enabled) speak(host.dataset.actionsOn);
  });
  function readControl(event) {
    if (!actionsEnabled) return;
    const el = event.target.closest('button,a[href],summary,input,select,textarea,[role="button"],[role="checkbox"]');
    if (!el || el === actionsButton || el.hasAttribute('data-a11y-reset')) return;
    const labelled = (el.getAttribute('aria-labelledby') || '').split(/\s+/).map(id => document.getElementById(id)?.textContent || '').join(' ');
    const label = el.getAttribute('aria-label') || labelled.trim() || [...(el.labels || [])].map(l=>l.textContent).join(' ') || (el.matches('input,textarea,select') ? el.getAttribute('placeholder') : el.innerText);
    if (!label?.trim()) return;
    const link = el.closest('a[href]');
    let navigate;
    if (link && !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !link.download && (!link.target || link.target === '_self')) {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname !== location.pathname) {
        event.preventDefault();
        let followed = false;
        navigate = () => { if (!followed) { followed = true; location.assign(url.href); } };
        setTimeout(navigate, 2500);
      }
    }
    clearTimeout(actionTimer);
    actionTimer = setTimeout(() => {
      if (!actionsEnabled) return;
      window.speechSynthesis?.cancel();
      const checked = el.getAttribute('aria-pressed') ?? el.getAttribute('aria-checked');
      const suffix = checked === 'true' ? (language === 'he' ? ', פעיל' : ', on') : checked === 'false' ? (language === 'he' ? ', כבוי' : ', off') : '';
      speak(label.trim().slice(0,220) + suffix, navigate);
    }, 120);
  }
  document.addEventListener('click', readControl);
  const guide = host.querySelector('.soffa-reading-guide');
  document.addEventListener('pointermove', event => { if (prefs.guide) guide.style.top = `${event.clientY}px`; }, { passive: true });
  document.addEventListener('focusin', event => { if (prefs.guide && event.target instanceof HTMLElement) guide.style.top = `${event.target.getBoundingClientRect().top}px`; });
  window.addEventListener('pagehide', () => { actionsEnabled = false; clearTimeout(actionTimer); stopReading(); });
  window.speechSynthesis?.getVoices();
  new MutationObserver(records => {
    if (records.every(record => host.contains(record.target))) return;
    if (pending || (!prefs.size && !prefs.motion && !motionQuery.matches)) return;
    pending = requestAnimationFrame(() => {
      pending = 0;
      resizeText();
      reduceMotion();
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  window.addEventListener('resize', () => {
    if (pending || !prefs.size) return;
    pending = requestAnimationFrame(() => { pending = 0; resizeText(); });
  });
  motionQuery.addEventListener('change', reduceMotion);
  for (const name of ['slideshow-component', 'announcement-bar-component']) customElements.whenDefined(name).then(reduceMotion);
  apply(false);
  launcher.hidden = false;
})();
